(function (appComponents) {
	// move to gridlist proto
	appComponents.controllers.ordersOverview = function (Components) {
		var ordersOverview = {};

		ordersOverview.name = "ordersOverview";

		Components.getControllerPrototype().extend(ordersOverview);

		ordersOverview._orders = ordersOverview._getService("ordersBase");
		ordersOverview._b2bUnit = ordersOverview._getService("b2bUnit");
		ordersOverview._helpers = ordersOverview._getService("helpers");

		ordersOverview.searchOrdersView = ordersOverview._getPageComponent("searchOrdersView");
		ordersOverview.savedOrdersView = ordersOverview._getPageComponent("savedOrdersView");

		ordersOverview.elements = {
			get ordersGrid() {
				return $('[pc-container="orders--grid"]');
			},
			get ordersList() {
				return $('[pc-container="orders--list"]');
			},
			get ordersGridSaved() {
				return $('[pc-container="orders--grid-saved"]');
			},
			get ordersListSaved() {
				return $('[pc-container="orders--list-saved"]');
			},
			get savedOrdersViewBtn() {
				return $('[pc-container="orders--switch-orders-view-btn"][pc-value="savedOrders"]');
			},
			get searchOrdersViewBtn() {
				return $('[pc-container="orders--switch-orders-view-btn"][pc-value="searchOrders"]');
			},
			get filtersForm() {
				return $('[pc-container="orders--filters-form"]');
			},
			get searchByTermForm() {
				return $('[pc-container="orders--search-by-term-form"]');
			},
			get searchByCustomerForm() {
				return $('[pc-container="orders--search-by-customer-form"]');
			}

		};

		ordersOverview.bindings = function () {

			ordersOverview._elements.page.on("click", '[pc-container="orders--set-grid-list-view-btn"]', function () {
				var type = $(this).attr("pc-value");
				ordersOverview[ordersOverview.currentView + "View"].handlers.onSetTabView(type);
			});

			ordersOverview._elements.page.on("click", '[pc-container="orders--switch-orders-view-btn"]', function () {
				var orderView = $(this).attr("pc-value");
				if (ordersOverview.currentView == orderView) return;
				ordersOverview.currentView = orderView;
				ordersOverview[orderView + "View"].init();
			});

			ordersOverview._elements.page.on("submit", '[pc-container="orders--filters-form"]', function () {
				ordersOverview.elements.searchByTermForm.trigger("reset");
				ordersOverview.elements.searchByCustomerForm.trigger("reset");
				ordersOverview.searchOrdersView.handlers.onFilterFormSubmit(this);
				return false;
			});

			ordersOverview._elements.page.on("submit", '[pc-container="orders--search-by-term-form"]', function () {
				ordersOverview.elements.filtersForm.trigger("reset").find("input:checkbox").removeAttr("checked").iCheck("update");
				ordersOverview.elements.searchByCustomerForm.trigger("reset");
				ordersOverview.searchOrdersView.handlers.onFilterFormSubmit(this);
				return false;
			});

			ordersOverview._elements.page.on("submit", '[pc-container="orders--search-by-customer-form"]', function () {
				ordersOverview.elements.filtersForm.trigger("reset").find("input:checkbox").removeAttr("checked").iCheck("update");
				ordersOverview.elements.searchByTermForm.trigger("reset");
				ordersOverview.searchOrdersView.handlers.onFilterFormSubmit(this);
				return false;
			});

			ordersOverview._elements.page.on("click", '[pc-container="orders-overview--reset-filters-btn"]', function () {
				ordersOverview.elements.filtersForm.trigger("reset").find("input:checkbox").removeAttr("checked").iCheck("update");
				ordersOverview.elements.searchByTermForm.find("input").val("");
				ordersOverview.elements.searchByCustomerForm.find("input").val("");
				ordersOverview.handlers.onResetFilters();
			});
			ordersOverview._elements.page.on("click", '[pc-container="orders--export-to-excel-button"]', function () {
				// inputs 
				var form = $('[pc-container="orders--export-to-excel-form"]');
				ordersOverview.handlers.onExportToExcel(form);
			});

		};

		ordersOverview.populateInitialContext = function () {
			ordersOverview.context.searchData = ordersOverview._queryData;
			return ordersOverview._api.orders.getStatusFilters().then(function (res) {
				if (res && res.status == 200) {
					ordersOverview.context.statusFilters = res.body;
				}
			});
		};

		ordersOverview.setDefaultView = function () {
			var queryData = ordersOverview._queryData;
			var viewNameToInit = "searchOrdersViewBtn";

			if (queryData && queryData.view == "searchOrders" || queryData.view == "savedOrders") {
				viewNameToInit = queryData.view + "ViewBtn";
			}

			ordersOverview.elements[viewNameToInit].click();
		};

		ordersOverview.resetViews = function () {
			ordersOverview.searchOrdersView.savedQueryData = null;
			ordersOverview.savedOrdersView.savedQueryData = null;

			//ordersOverview.searchOrdersView.currentTabView = "list";
			//ordersOverview.savedOrdersView.currentTabView = "list";

		};

		ordersOverview.renderLastOrders = function () {

			if (ordersOverview._b2bUnit.isUnitSet) {

				ordersOverview.searchOrdersView.searchOrdersWithPager();
				ordersOverview.savedOrdersView.searchOrdersWithPager();

			} else {

				ordersOverview.context.orders = [];
				ordersOverview.searchOrdersView.renderSearchResults();
				ordersOverview.savedOrdersView.renderSavedResults();
			}
		};
		ordersOverview.prepareSearchData = function () {
			var searchData = ordersOverview._queryData;

			if (!searchData.resultsPerPage) {
				searchData = {
					resultsPerPage: ordersOverview.opts.numToDisplay,
					pageNumber: 1
				};

				ordersOverview._updateUrlQuery("replace", searchData);
			}

			return searchData;

		};
		ordersOverview.handlers = {
			onResetFilters: function () {
				ordersOverview.searchOrdersView.resetFilters();

			},
			onb2bUnitChange: function () {
				if (ordersOverview._isActiveController) {
					ordersOverview.renderLastOrders();
				}
			},
			onSavedOrderDeleted: function () {
				if (ordersOverview._isActiveController) {
					ordersOverview.savedOrdersView.getSavedOrders();
				}
			},
			onExportToExcel: function (form) {
				var searchData = ordersOverview.prepareSearchData();
				searchData.CSRFToken = ordersOverview.context.config.token;
				searchData.customerIndexNo = ordersOverview._b2bUnit.currentUnit.uid;
				ordersOverview._helpers.populateFormWithHiddenFields(form, searchData);
				$(form).submit();
			},
			onFilterFormSubmit: function (form) {
				var access = ordersOverview._b2bUnit.checkB2BUnit();
				if (!access) {
					ordersOverview._modals.warning.show(ordersOverview._messages.noB2bUnitSelected);
					return;
				}

				var formData = ordersOverview._utils.getFormData(form, true);

				ordersOverview.pager.reset();
				
				var pagerData = {
						pageNumber: ordersOverview.pager.pageToSet,
						resultsPerPage: ordersOverview.pager.pageSize
					};

				var queryData = jQuery.extend({}, formData, pagerData);

				ordersOverview._updateUrlQuery("push", queryData); 

				ordersOverview.searchQuotesWithPager();
			},
		};

		ordersOverview.init = function () {

			ordersOverview.currentView = null;

			ordersOverview.populateInitialContext().then(function () {

				ordersOverview._renderPageTemplate();

				// force icheck init in case of controllerInitialized event does not start in time
				ordersOverview._applyScript.base.iCheck();

				ordersOverview._bindings();

				ordersOverview.resetViews();

				ordersOverview.setDefaultView();

				ordersOverview.renderLastOrders();

				ordersOverview._events.registerHandlerAsLastOne("b2bUnitChanged", ordersOverview.name, ordersOverview.handlers.onb2bUnitChange);

				ordersOverview._events.registerHandlerAsLastOne("savedOrderDeleted", ordersOverview.name, ordersOverview.handlers.onSavedOrderDeleted);

				ordersOverview._events.dispatchEvent("controllerInitialized");

			});

		};

		return ordersOverview;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});